import { Link } from "wouter";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export function CancelPage() {
  return (
    <Card className="font-sans w-full max-w-md">
      <CardHeader>
        <div className="flex justify-center">
          <XCircle className="size-16 text-destructive" aria-hidden />
        </div>
        <CardTitle className="text-center text-xl sm:text-2xl">
          Pagamento annullato
        </CardTitle>
        <CardDescription className="text-center">
          Il pagamento non è stato completato. Puoi riprovare quando vuoi.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button asChild size="lg" variant="default" className="w-full min-h-[44px] bg-primary text-primary-foreground hover:bg-primary/90">
          <Link href="/register">Riprova</Link>
        </Button>
      </CardContent>
    </Card>
  );
}
